import { MARQUEE_WORDS } from "../../data";

export const Marquee = () => {
  const items = [...MARQUEE_WORDS, ...MARQUEE_WORDS];
  return (
    <section
      data-testid="marquee"
      className="marquee-track relative border-y border-white/10 bg-[#0a0a0a] py-6 md:py-8 overflow-hidden"
    >
      <div className="flex w-max animate-marquee will-change-transform">
        {items.map((w, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display uppercase text-3xl md:text-5xl text-white/[0.14] px-10 md:px-16 whitespace-nowrap">
              {w}
            </span>
            <span className="text-[#e5ff00] text-2xl md:text-3xl">✦</span>
          </div>
        ))}
      </div>
    </section>
  );
};
